export default __webpack_public_path__ + "static/media/Instagram.0b748a01.svg";